<template>
    <div class="login">
        <div class="header-top">
            <van-dropdown-menu>
                <van-dropdown-item v-model="value1" :options="option1" @change="changeClick" />
            </van-dropdown-menu>
        </div>
        <div class="login_l">
            登录
        </div>
        <div class="login_form">
            <el-form label-position="top" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                class="demo-ruleForm">
                <el-form-item label="登录账户" prop="account">
                    <el-input placeholder="请输入账户" v-model="ruleForm.account" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="password">
                    <el-input :show-password='true' placeholder="请输入密码" type="password" v-model="ruleForm.password"
                        autocomplete="off"></el-input>
                    <div class="d-flex justify-between align-center fn-12">
                        <p>
                            <span>没有账户，</span>
                            <span style="color:#f89b19" @click="goLink('/member/register', 2)">立即注册</span>
                        </p>
                        <p style="color:#f89b19" @click="goLink('/member/Retrieve', 2)">忘记密码</p>
                    </div>
                </el-form-item>

                <el-form-item>
                    <div class="login_btn">
                        <el-button :loading="IsLoading" type="primary" @click="submitForm('ruleForm')">登录</el-button>
                    </div>


                </el-form-item>
            </el-form>
        </div>


        <!-- -->




    </div>
</template>
<script>
import Vue from 'vue';
import { NoticeBar, Icon, DropdownMenu, DropdownItem } from 'vant';
Vue.use(NoticeBar).use(Icon).use(DropdownItem).use(DropdownMenu);
import vueQr from "vue-qr";
import {
    mainApiData
} from '@/request/api.js';
import { mapMutations } from 'vuex';
import {
    linkWallet
} from "../../../public/static/linkWallet.js";
export default {
    components: {
        vueQr,
    },
    data() {
        return {
            baseApi: "",
            UrlYqhy: "",
            Aeccter: {
                money: 75.8193,

            },
            ruleForm: {
                account: '',
                password: '',

            },
            rules: {
                account: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                password: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],

            },
            IsLoading: false,
            value1: 0,
            option1: [{
                text: '普通登录',
                value: 0
            }, {
                text: '钱包登录',
                value: 1
            }],
            tcshow:true



        }
    },
    created() {
        this.baseApi = process.env.VUE_APP_IMG;
        this.UrlYqhy = window.location.origin + '/#/reg?promotion=' + '1111';
    },
    methods: {
        ...mapMutations(['login']),
        changeClick(e) {
            if (e == 1) {
                linkWallet((bool, chainId, address) => {
                    console.log(address, 'address');
                    if (address == '' || address == null) {
                        return window.location.href = 'https://www.tpwallet.io/'

                    }
                    mainApiData.loginAddr({
                        address: address
                    }).then((res) => {
                        if (res.data.code == 200) {
                            sessionStorage.setItem('ms_user', JSON.stringify(res.data.data));
                            this.$store.commit("setMember", res.data.data.user);
                            localStorage.setItem("TOKEN", res.data.data.token);

                            this.$toast('登录成功');
                            var that = this;
                            setTimeout(() => {
                                that.$router.push("/");
                            }, 2000);
                        } else {
                            this.$toast(res.data.msg);
                            this.value1 = 0;
                        }
                    })
                })
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.IsLoading = true;
                    mainApiData.login(this.ruleForm).then((res) => {
                        if (res.data.code == 200) {
                            this.$toast('登录成功');
                            var that = this;
                            sessionStorage.setItem('ms_user', JSON.stringify(res.data.data));
                            this.$store.commit("setMember", res.data.data.user);
                            localStorage.setItem("TOKEN", res.data.data.token);
                            // 调用login函数进行登录操作
                            this.login({ username: this.ruleForm.account, password: this.ruleForm.password })
                            setTimeout(() => {
                                that.$router.push("/");
                            }, 2000);
                            this.IsLoading = false;
                        } else {
                            this.$toast(res.data.msg);
                            this.IsLoading = false;
                        }

                    })
                    this.IsLoading = false;
                } else {
                    this.IsLoading = false;
                    return false;
                }
            });
        },
        onCopy() {
            this.$toast(this.$t('myself.a23'))
        },
        goLink(path, item) {
            // linkWallet((bool, chainId, address) => {
            //     console.log(address, 'address');
            //     if (address == '' || address == null) {
            //         return window.location.href = 'https://www.tpwallet.io/'

            //     }
            //     if (path) {
            //         this.$router.push({
            //             path,
            //             query: {
            //                 item: JSON.stringify(item),
            //             }
            //         });
            //     } else {
            //         // 暂未开放
            //         this.$toast(this.$t('orePond.a42'));
            //     }
            // })
            if (path) {
                    this.$router.push({
                        path,
                        query: {
                            item: JSON.stringify(item),
                        }
                    });
                } else {
                    // 暂未开放
                    this.$toast(this.$t('orePond.a42'));
                }
        }

    }
}
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";

.login {
    margin: 0px 10px;

    .header-top {
        ::v-deep .van-cell {
            border: none;
        }

        width: 100%;

        ::v-deep .van-dropdown-menu__bar {
            background: transparent !important;
            color: #fff;
        }

        ::v-deep .van-ellipsis {
            font-size: 16px;
            // margin-left: -10px;
            color: #fff;
        }

        ::v-deep(.van-popup) {
            // border: 0.5px solid #f89b19;
            box-shadow: 0px 0px 6px 2px #f89b19, inset 0px 0px 6px -2px #f89b19;
            border-radius: 4px;
            background: transparent;
            color: #fff;


        }

        ::v-deep(.van-cell) {
            color: #fff;
        }
    }

    ::v-deep .van-nav-bar__title {
        color: #fff;
    }

    .login_l {
        padding: 138px 0 30px 0;
        // border: 1px solid red;
        // display: flex;
        // justify-content: center;
        // align-items: center;
        // flex-direction: column;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 40px;
        line-height: 56px;
        /* identical to box height */

        letter-spacing: 0.0703846px;

        /* 黄/主题 */

        color: #f89b19;


    }

    .login_form {
        ::v-deep .el-form-item__label:before {
            display: none;
        }

        ::v-deep .el-form-item__label {
            padding: 10px 0 !important;
            font-family: 'PingFang SC';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;

            /* 白/FE */

            color: #FEFEFE;
        }

        ::v-deep .el-input__inner {
            background: transparent;
            color: #FEFEFE;
            /* 黄/主题 */

       
            // box-shadow: 0px 0px 6px 2px #f89b19, inset 0px 0px 6px -2px #f89b19;
            border: 1px solid #f89b19;
            border-radius: 4px;
        }
    }

    .login_btn {
        /* Frame 147 */


        /* Auto layout */

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        // padding: 10px;
        // gap: 10px;

        // position: absolute;

        width: 100%;
        // left: 15px;
        padding: 70px 0;

        ::v-deep .el-button {
            width: 100%;
            background: #f89b19;
            border: 0;
        }

        /* 黄/主题 */

        color: #FFFFFF;
    }



    .Assets_grid {

        ul {
            display: grid;
            justify-content: space-between;
            grid-template-columns: 25% 25% 25% 25%;
            text-align: center;

            li {
                margin-top: 17px;

                img {
                    // margin: 10px 0;
                }

                p {
                    // padding: 8.74px 0px 15px 0;
                    color: #fff;
                    font-size: 12px;
                }
            }

            // align-items: center;
        }
    }

    .Assets_ul {
        ul {
            li {
                margin: 20px 10px;
                background: rgba(20, 132, 195, 0.2);
                /* 黄/主题 */

                border: 0.5px solid #f89b19;
                box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
                border-radius: 4px;

                div {
                    &:nth-child(1) {
                        padding: 10px 15px;

                        p {
                            font-style: normal;
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 20px;
                            text-align: center;

                            color: #FFFFFF;




                        }
                    }



                }
            }
        }
    }

}
</style>